// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"


export default {
	name: "BreedTableComponent",
	mixins: [tableMixins, toastMessageMixins],
	props: {
		applicableBreeds: {
			type: Array,
			default: null,
		}
	},
	data() {
		return {
			isBreedsAPILoading: false,
			initialLoad: true,
			// table
			theads: [
				{
					name: "Breeds",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: "width: 90%",
				}
			],
			filterQuery: "",
			filteredResults: [],
		}
	},
	mounted: function() {
    },
	watch: {
	},
	methods: {
	}
}
